// import { btn } from '../../AbstractElements';
// import { dynamicImage } from "../../Services"
import React, { useEffect, useState } from "react";
// import axios from "axios";
import EditUser from "../../Components/User/EditUser";
import AddAdminUser from "../../Components/User/AddAdminUser";
import DetailInfoAdmin from "../../Components/User/DetailInfoAdmin";
import { ServerPath } from "../../Constant";
import { _axios } from "../../utils/axios";

export const tableColumns = [
  {
    name: "User ID",
    selector: (row) => row.user_id,
    cell: (row) => <DetailInfoAdmin data={row} />,
    sortable: true,
    center: true,
    width: "15rem",
  },
  {
    name: "Name",
    selector: (row) => row?.user_name ?? "" + " " + row?.last_name ?? "",
    sortable: true,
    center: true,
    width: "25rem",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    center: true,
    width: "9.375rem",
  },
  {
    name: "Phone Number",
    selector: (row) => row.mobile,
    sortable: true,
    center: true,
    width: "12rem",
  },
  {
    name: "Alternate Phone Number",
    selector: (row) => row.alt_phone_number,
    sortable: true,
    center: true,
    width: "12rem",
  },
  {
    name: "Last Modified Date",
    selector: (row) => row.lastModifiedOn,
    sortable: true,
    center: true,
    width: "12rem",
  },
  {
    name: "Action",
    selector: (row) => row.action,
    sortable: true,
    center: true,
    width: "15rem",
  },
];

const handleDelete = async (userId, setUsers) => {
  try {
    await _axios.delete(`${ServerPath}/web-users/${userId}`);
    setUsers((prevUsers) =>
      prevUsers.filter((user) => user.user_id !== userId)
    );
  } catch (error) {
    console.error("Error deleting user:", error);
  }
};

export const FetchUserData = async () => {
  const [users, setUsers] = useState([]);
  const [dummyTableData, setDummyTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/web-users`);
        console.log("Response data:", response.data); // Log response data
        const actualData = response.data.data;
        const userData = actualData.map((user) => ({
          ...user,
          // user_name: <div className="align-self-center"><div>{user.user_name}</div></div>,
          action: (
            <div className="action d-flex justify-content-center">
              <div
                className="edit"
                data-bs-toggle="modal"
                data-bs-target="#exampleModalCenter"
              >
                <AddAdminUser data={user} isEditButton={true} />
              </div>

              <button className="btn-square">
                <div className="delete">
                  <a
                    href="#"
                    onClick={() => handleDelete(user.user_id, setUsers)}
                    className="link-danger"
                  >
                    <i className="icon-trash"></i>
                  </a>
                </div>
              </button>
            </div>
          ),
        }));
        setUsers(userData);
        setDummyTableData(userData); // Set dummyTableData
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchData();
  }, []);

  return dummyTableData;
};

// {
//     id: 4,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/3.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Brielle Willamson</div>
//         </div>
//     </div>,
//     date: '2023/03/09',
//     invoice: '#G189d0',
//     designation: 'Senior Javascript Developer',
//     credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 2.2%</span>,
//     company: 'Microsoft',
//     priority: <span className='badge badge-light-info'>Medium</span>,
//     budget: '$7689.00',

// },
// {
//     id: 5,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/4.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Tiger Nixon</div>
//         </div>
//     </div>,
//     date: '2023/04/10',
//     invoice: '#31D8FFS',
//     designation: 'Accountant',
//     credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 5.8%</span>,
//     company: 'Tata Co.',
//     priority: <span className='badge badge-light-primary'>High</span>,
//     budget: '$2145.00',

// },
// {
//     id: 6,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/5.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Michel Morris</div>
//         </div>
//     </div>,
//     date: '2023/06/12',
//     invoice: '#G189D4',
//     designation: 'General service',
//     credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 6.4%</span>,
//     company: 'Google Inc.',
//     priority: <span className='badge badge-light-danger'>Urgent</span>,
//     budget: '$2578.00',

// },
// {
//     id: 7,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/6.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Glen Matney</div>
//         </div>
//     </div>,
//     date: '2023/04/25',
//     invoice: '#PX2101',
//     designation: 'System Architect',
//     credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 0.3%</span>,
//     company: 'Mindtree Ltd.',
//     priority: <span className='badge badge-light-success'>Low</span>,
//     budget: '$6538.00',

// },
// {
//     id: 8,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/7.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Ashton Cox</div>
//         </div>
//     </div>,
//     date: '2023/06/09',
//     invoice: '#px0101',
//     designation: 'System Architect',
//     credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 7.3%</span>,
//     company: 'Wipro Ltd.',
//     priority: <span className='badge badge-light-danger'>Urgent</span>,
//     budget: '$2121.00',

// },
// {
//     id: 9,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/8.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Tiger Nixon</div>
//         </div>
//     </div>,
//     date: '2023/01/11',
//     invoice: '#G5384H',
//     designation: 'General service',
//     credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 6.3%</span>,
//     company: 'Edinburgh',
//     priority: <span className='badge badge-light-primary'>High</span>,
//     budget: '$9546.00',

// },
// {
//     id: 10,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/9.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Brielle Williamson</div>
//         </div>
//     </div>,
//     date: '2023/04/02',
//     invoice: '#E5384H',
//     designation: 'System Architect',
//     credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 3.3%</span>,
//     company: 'Mphasis Ltd',
//     priority: <span className='badge badge-light-info'>Medium</span>,
//     budget: '$4587.00',

// },
// {
//     id: 11,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/10.jpg"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Charles Kubik</div>
//         </div>
//     </div>,
//     date: '2023/05/01',
//     invoice: '#JK384H',
//     designation: 'System Architect',
//     credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 2.3%</span>,
//     company: 'Infosys Ltd.',
//     priority: <span className='badge badge-light-success'>Low</span>,
//     budget: '$3140.00',

// },
// {
//     id: 12,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/11.png"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Brielle Williamson</div>
//         </div>
//     </div>,
//     date: '2023/07/04',
//     invoice: '#HY5384H',
//     designation: 'General service',
//     credit: <span className="f-w-700 font-danger"><i className="icofont icofont-arrow-down"></i> 1.3%</span>,
//     company: 'Edinburgh',
//     priority: <span className='badge badge-light-success'>Low</span>,
//     budget: '$3014.00',

// },
// {
//     id: 13,
//     name: <div className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: dynamicImage("user/12.png"), alt: 'Generic placeholder image' }} />
//         <div className="align-self-center">
//             <div>Kevin Dawson</div>
//         </div>
//     </div>,
//     date: '2023/04/06',
//     invoice: '#KH384H',
//     designation: 'System Architect',
//     credit: <span className="f-w-700 font-success"><i className="icofont icofont-arrow-up"></i> 5.3%</span>,
//     company: 'Infosys.',
//     priority: <span className='badge badge-light-danger'>Urgent</span>,
//     budget: '$2014.00',

// }
